import React from "react";
import { COGNITO_ACCESS_TOKEN_KEY, ssciamIsEnabled, hasValidCognitoToken } from "../authHelper";
import { AuthLabel } from "./AuthLabel";

export const CognitoAuthLabel = () => {
  const enabled = ssciamIsEnabled();

  if (!enabled) {
    return null;
  }

  hasValidCognitoToken(); // removes the token if invalid

  return <AuthLabel tokenKey={COGNITO_ACCESS_TOKEN_KEY} label="Old login" colorClass="cognito" />;
};
